import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import { List } from 'chaoskit/src/components'
import check from 'chaoskit/src/assets/icons/check.svg'
import { getComputedLineHeight } from 'chaoskit/src/assets/styles/utility/misc'

const Checklist = ({ columns, ...rest }) => {
  const theme = useTheme()

  return (
    <List
      space="small"
      css={{
        margin: 0,

        '> .CK__ListItem': {
          display: 'grid',
          gridAutoFlow: 'column',
          gridAutoColumns: 'auto',
          gap: theme.space.small,
          justifyContent: 'start',

          // 1. Calc for body copy offset
          '&::before': {
            content: "''",
            display: 'block',
            width: getComputedLineHeight({
              fontSize: theme.fontSize.base,
              lineHeight: theme.lineHeight.base,
            }),
            height: getComputedLineHeight({
              fontSize: theme.fontSize.base,
              lineHeight: theme.lineHeight.base,
            }),
            backgroundImage: `url(${check})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
            backgroundSize: `${theme.fontSize.base}px ${theme.fontSize.base}px`,
            filter: theme.color.primary.filter,
          },
        },
      }}
      {...rest}
    />
  )
}

Checklist.propTypes = {
  columns: PropTypes.bool,
}

export default Checklist
